import { action } from 'utils/actions'

export const DRAFT_EVENTGROUP_CANCEL = 'DRAFT_EVENTGROUP_CANCEL'
export const DRAFT_EVENTGROUP_EDIT = 'DRAFT_EVENTGROUP_EDIT'
export const DRAFT_EVENTGROUP_SAVE = 'DRAFT_EVENTGROUP_SAVE'
export const DRAFT_EVENTGROUP_UPDATE_FIELD = 'DRAFT_EVENTGROUP_UPDATE_FIELD'

export const draftEventGroupCancel = () => action(DRAFT_EVENTGROUP_CANCEL)
export const draftEventGroupEdit = eventGroup => action(DRAFT_EVENTGROUP_EDIT, { eventGroup })
export const draftEventGroupSave = () => action(DRAFT_EVENTGROUP_SAVE)
export const draftEventGroupUpdateField = (eventGroupId, data) => action(DRAFT_EVENTGROUP_UPDATE_FIELD, { eventGroupId, data }) // eslint-disable-line



/** WEBPACK FOOTER **
 ** ./src/actions/draft/eventgroup/draft-eventgroup.js
 **/